import React from "react";
import { Tooltip } from "antd";
import Icons from "components/icons";
import { Localize } from "components/service";
import {
    getStaffAuditReason,
    getStaffAuditReasonDetail,
    getStaffAuditResult,
} from "../helpers/staff-audit-log-presentation-helper";


const reasonIcons = {
    within_radius: Icons.StaffLocation,
    outside_radius: Icons.StaffLocationFailed,
    duplicate_scan: Icons.StaffQrCode,
    open_session_elsewhere: Icons.StaffQrCode,
    location_permission_denied: Icons.StaffLocationFailed,
    camera_permission_denied: Icons.StaffCameraAccess,
    outside_schedule: Icons.StaffClock,
    location_unavailable: Icons.StaffLocationFailed,
    no_open_session: Icons.StaffQrCode,
    same_device: Icons.StaffSameDevice,
    invalid_qr: Icons.StaffInvalidQr,
    outdated_qr: Icons.StaffInvalidQr,
    manual_close: Icons.StaffCheckOut,
};

const reasonHints = {
    duplicate_scan: "STAFF_MANAGEMENT.AuditReason_AlreadyCheckedIn_Hint",
    open_session_elsewhere: "STAFF_MANAGEMENT.AuditReason_OpenSessionElsewhere_Hint",
};

const StaffAuditReasonField = ({ auditLog }) => {
    const reason = getStaffAuditReason(auditLog?.reason);
    const reasonDetail = getStaffAuditReasonDetail(auditLog);
    const result = getStaffAuditResult(auditLog?.status);
    const ReasonIcon = reasonIcons[ reason ];
    const hintKey = reasonHints[ reason ];

    const content = (
        <span
            className={ `staff-audit-reason staff-audit-reason--${ reason } staff-audit-reason--result-${ result }` }
            tabIndex={ hintKey ? 0 : undefined }>
            { ReasonIcon &&
                <span className="d-flex align-items-center justify-content-center staff-audit-reason__icon" aria-hidden="true">
                    <ReasonIcon />
                </span>
            }
            <span className="staff-audit-reason__text">
                { reason === "manual_close" && !reasonDetail ?
                    <Localize>STAFF_MANAGEMENT.ManualCheckout_UnknownActor</Localize> :
                    <Localize worker={ reasonDetail || "—" } name={ reasonDetail }>
                        { `STAFF_MANAGEMENT.AuditReason_${ reason }` }
                    </Localize>
                }
                { reason === "open_session_elsewhere" && reasonDetail &&
                    <span className="staff-audit-reason__detail">
                        { reasonDetail }
                    </span>
                }
            </span>
        </span>
    );

    return hintKey ? (
        <Tooltip
            title={ <Localize>{ hintKey }</Localize> }
            trigger={ [ "hover", "focus" ] }>
            { content }
        </Tooltip>
    ) : content;
};

export default StaffAuditReasonField;
